import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentCtx = createContext(null);
export const useContent = () => useContext(ContentCtx);

export function ContentProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [policies, setPolicies] = useState([]);
  const [beliefs, setBeliefs] = useState([]);
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    const [s, p, b, d] = await Promise.all([
      api.get("/content/settings"),
      api.get("/content/policies"),
      api.get("/content/beliefs"),
      api.get("/content/donations"),
    ]);
    setSettings(s.data);
    setPolicies(p.data);
    setBeliefs(b.data);
    setDonations(d.data);
    setLoading(false);
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <ContentCtx.Provider value={{ settings, policies, beliefs, donations, loading, refetch }}>
      {children}
    </ContentCtx.Provider>
  );
}
